const ORIGIN = window.location.origin;
export const COLLEGE = window.location.href.split('/')[3];


export function URL(academicType) {
    if(academicType==='UNIVERSITY'){
        return  ORIGIN + '/dhi-university-apiserver/api';
    }else{
        return  ORIGIN + '/dhiapiserver/api';
    }
}